import { Button, Divider, Form, Input, message, PageHeader } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as userAPI from "../../api/user";

const AuthTimer = ({ expireAt }) => {
  const [time, setTime] = useState(299);

  useEffect(() => {
    if (time > 0) {
      const Counter = setInterval(() => {
        const gap = Math.floor(
          (new Date(expireAt).getTime() - new Date().getTime()) / 1000
        );
        setTime(gap);
      }, 1000);
      return () => clearInterval(Counter);
    }
  }, [expireAt, time]);
  const timeFormat = (time) => {
    const m = Math.floor(time / 60).toString();
    let s = (time % 60).toString();
    if (s.length === 1) s = `0${s}`;
    return `${m}:${s}`;
  };
  return (
    <>
      <p
        style={{
          textAlign: "right",
          fontSize: "14px",
          letterSpacing: "-0.4px",
        }}
      >
        유효 시간 {timeFormat(time)}
      </p>
    </>
  );
};

function SignIn() {
  const [form] = Form.useForm();
  const email = Form.useWatch("email", form);
  const password = Form.useWatch("password", form);

  const navigate = useNavigate();

  const handleOk = () => {
    sessionStorage.removeItem("accessToken");

    userAPI
      .login({ email, password })
      .then((res) => {
        if (res.data.linusCode === 1) {
          message.success("성공적으로 로그인되었습니다.");
          sessionStorage.setItem(
            "accessToken",
            res.data.data.tokens.accessToken
          );
          sessionStorage.setItem(
            "email",
            email
          );
          navigate("/");
        } else {
          message.error(res.data.data.msg);
        }
      })
      .catch((error) => {
        if (error.response.data.detail) {
          message.error(error.response.data.detail);
        } else if (error.response.status < 500) {
          for (let key of Object.keys(error.response.data)) {
            message.error(`${key}: ${error.response.data[key]}`);
          }
        } else {
          message.error("오류가 발생했습니다.");
        }
      });
  };

  return (
    <div style={{}}>
      <div>
        <PageHeader className="site-page-header" title={"로그인"} />
        <Divider />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Form form={form}>
          <Form.Item name="email" label="이메일">
            <Input placeholder="이메일을 입력하세요" />
          </Form.Item>
          <Form.Item name="password" label="패스워드">
            <Input placeholder="패스워드를 입력하세요" type={"password"} />
          </Form.Item>
          <Form.Item>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                type="primary"
                htmlType="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleOk();
                }}
              >
                로그인
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default SignIn;
